import { BackupState } from '../../ToastContent'

export const findBackupToastContent = (isBackupDone, isCurrentlyTryingToBackup) => {
    if (isBackupDone)
        return BackupState.done
    else if (isCurrentlyTryingToBackup)
        return BackupState.ongoing
    return BackupState.default
}